window.addEventListener('load', () => {
    let mobileMenu = document.querySelector('.mobile-menu')

    if(mobileMenu) {
        let toggleMenu = document.querySelector('.toggle-menu')

        mobileMenu.classList.add('loaded')

        if(toggleMenu) {
            toggleMenu.addEventListener('click', () => {
                mobileMenu.classList.toggle('show')
                toggleMenu.classList.toggle('icon-close')
                toggleMenu.classList.toggle('icon-menu')

                checkHeader()
            })
        }
    }
})

let mobileMenuItems = document.querySelectorAll('.mobile-menu .menu-item-has-children')

if(mobileMenuItems.length) {
    for(let item of mobileMenuItems) {
        item.querySelector('a').insertAdjacentHTML('beforeend', '<span class="mobile-menu-item-toggler icon-down">')
    }

    let mobileMenuItemIoggler = document.querySelectorAll('.mobile-menu-item-toggler')

    if(mobileMenuItemIoggler.length) {
        for(let item of mobileMenuItemIoggler) {
            let parent = item.parentElement
            parent.addEventListener('click', (e) => {
                let menu = parent.nextElementSibling

                if(item.classList.contains('active')) {
                    item.classList.remove('active')
                    menu.hide()
                } else {
                    item.classList.add('active')
                    menu.show()
                }

                e.preventDefault()
            })
        }
    }
}

let darkableHeader = document.querySelector('.site-header.darkable')

function checkHeader() {
    let scroll = window.pageYOffset
    let mobileMenu = document.querySelector('.mobile-menu')

    if(mobileMenu.classList.contains('show')) {
        scroll = 1
    }

    if(scroll) {
        darkableHeader.classList.remove('dark')
    } else {
        darkableHeader.classList.add('dark')
    }
}

if(darkableHeader) {
    checkHeader()

    window.addEventListener('scroll', checkHeader)
}